// extracted by mini-css-extract-plugin
export default {"pop-up":"style_pop-up__RRXAF","pop-up__backdrop":"style_pop-up__backdrop__BiFa1","pop-up__content":"style_pop-up__content__5ulfm"};